import React, { useState } from 'react';
import { IndicacionInput } from './IndicacionInput';
import { IndicacionesBAP } from '../../RIValidationCambioIndicacion/components/IndicacionesBAP';
import { CardContent, Card } from '@mui/material';
import './indicaciones.scss';

export const Indicaciones = ({
    idEvaluacion,
    idTipoModulo,
    readOnly = false,
    withoutCard,
    setCountIndicaciones,
    hasEsquemaBAP
}) => {
    const [childrenAction, setChildrenAction] = useState(null);

    return (
        <>
            {withoutCard ? (
                <IndicacionInput
                    idEvaluacion={idEvaluacion}
                    idTipoModulo={idTipoModulo}
                    setChildrenAction={setChildrenAction}
                    readOnly={readOnly}
                    setCountIndicaciones={setCountIndicaciones}
                />
            ) : (
                <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                    <CardContent>
                        <div className='step-form-section-container'>
                            <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                                Indicaciones
                                {!!childrenAction ? childrenAction : null}
                            </label>
                            {
                                !hasEsquemaBAP && <IndicacionInput
                                    idEvaluacion={idEvaluacion}
                                    idTipoModulo={idTipoModulo}
                                    setChildrenAction={setChildrenAction}
                                    readOnly={readOnly}
                                    setCountIndicaciones={setCountIndicaciones}
                                />
                            }
                            {hasEsquemaBAP && <IndicacionesBAP
                                idEvaluacion={idEvaluacion}
                                idTipoModulo={idTipoModulo}
                                setChildrenAction={setChildrenAction}
                                readOnly={readOnly}
                                setCountIndicaciones={setCountIndicaciones}
                            />
                            }

                        </div>
                    </CardContent>
                </Card>
            )}
        </>
    );
};
